export default function snakeToCamelCase(str) {
  return str.replace(
    /([-_][a-z])/g,
    (word) => word.toUpperCase()
      .replace("-", "")
      .replace("_", ""),
  )
}
